/*
 * Module for the benefit details tab of the Benefit Summary screen
*/

rs.module("framework/benefitsummary/benefitdetails",

    ["common/select-helper"],

    function (selectHelper) {

        //
        // Initialize
        //
        function initialize(jsSelectors, backendUrls) {

            var form = $.js(jsSelectors.form);

            // on payment address select change, clear payment representative select
            form.js(jsSelectors.paymentAddressSelect).change(function () { _clearSelect(form.js(jsSelectors.paymentRepSelect)); });

            // on payment representative select change, clear payment address select
            form.js(jsSelectors.paymentRepSelect).change(function () { _clearSelect(form.js(jsSelectors.paymentAddressSelect)); });

            // on tax address select change, clear tax representative select
            form.js(jsSelectors.taxAddressSelect).change(function () { _clearSelect(form.js(jsSelectors.taxRepSelect)); });

            // on tax representative select change, clear tax address select
            form.js(jsSelectors.taxRepSelect).change(function () { _clearSelect(form.js(jsSelectors.taxAddressSelect)); });

            // on month change, reload net benefit info
            form.js(jsSelectors.monthSelect).change(_loadNetBenefitInfo);

            // On click, open the gross net detail modal
            $.js(jsSelectors.grossNetDetailButton).click(function () {

                // show the popup
                $.js(jsSelectors.grossNetModal).modal("show");
            });

            // on year change, reload pay period months and net benefit info
            form.js(jsSelectors.yearSelect).change(function () {

                var monthSelect = form.js(jsSelectors.monthSelect);
                var yearSelect = $(this);

                form.js(jsSelectors.loadingSpinner).show();

                selectHelper.getHelper(monthSelect).loadOptionsFrom(
                    backendUrls.getPayPeriodMonths,
                    {
                        selectedYear: yearSelect.val(),
                        selectedMonth: monthSelect.val()
                    },
                    {},
                    function () {

                        // after changing years and reloading months, select the first month available for the year
                        selectHelper.getHelper(monthSelect).selectIndex(0);

                        _loadNetBenefitInfo();
                    });
            });

            // show/hide status history on hover
            form.js(jsSelectors.statusHistory).hoverIntent({
                handlerOver: function (event) {
                    form.js(jsSelectors.statusHistoryPopup).show();
                },
                handlerOut: function (event) {
                    form.js(jsSelectors.statusHistoryPopup).hide();
                },
                hoverOutDelay: 400
            });

            //
            // Calc new net benefit and load gross to net section
            //
            function _loadNetBenefitInfo() {

                var monthSelect = form.js(jsSelectors.monthSelect);
                var yearSelect = form.js(jsSelectors.yearSelect);

                form.js(jsSelectors.loadingSpinner).show();

                $.get(
                    backendUrls.calcNetBenefit,
                    {
                        selectedYear: yearSelect.val(),
                        selectedMonth: monthSelect.val()

                    }).done(function (result) {
                        form.js(jsSelectors.grossToNet).html(result);

                        form.js(jsSelectors.loadingSpinner).hide();
                    });
            }

            //
            // Helper function to clear one select based on the value of another
            //
            function _clearSelect(selectToClear) {
                if ($(this).val() != "") {
                    selectHelper.getHelper(selectToClear).setValue(null);
                }
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);